import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ControlledCheckbox } from '../../../../../shared';

const SDEmployeeSection = () => {
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.procedures.reports'
  });
  const { control } = useFormContext();

  return (
    <ControlledCheckbox
      control={control}
      name="incl_benefit_flag"
      label={t('inclBenefit')}
    />
  );
};

export default SDEmployeeSection;
